import {
  Create,
  SimpleForm,
  TextInput,
  DateInput
} from "react-admin";
export default function PhotoCreate(props) {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="title" />
        <DateInput source="updated_at" />
        <DateInput source="created_at" />
      </SimpleForm>
    </Create>
  );
}
